import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    backgroundColor: 'transparent',
  },
  separator: {
    marginRight: 7,
    // marginBottom: 10,
  },
});
